import { createCommand } from 'lexical';

interface OpenActionPickerCommand {
  anchorElement: HTMLElement;
  paragraphNodeKey?: string;
}

export const OPEN_ACTION_PICKER_COMMAND =
  createCommand<OpenActionPickerCommand>();
